module.exports = __webpack_public_path__ + "static/media/securesky-light.6b109d80.png";